import React, { useState, useEffect, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import './Home3.css';

const Ourwork = () => {
  const images = [
    "https://divyamads.com/wp-content/uploads/2022/10/01-1536x889.jpg",
    "https://divyamads.com/wp-content/uploads/2022/10/2-1.jpg",
    "https://divyamads.com/wp-content/uploads/2022/10/03-1536x889.jpg",
    "https://divyamads.com/wp-content/uploads/2022/10/04-1536x889.jpg",
    "https://divyamads.com/wp-content/uploads/2022/10/06-1536x889.jpg",
    "https://divyamads.com/wp-content/uploads/2022/10/06-1536x889.jpg",
  ];

  const slides = [
    [images[0], images[1]],
    [images[2], images[3]],
    [images[4], images[5]],
  ];

  const [slideIndex, setSlideIndex] = useState(0);
  const [selectedImg, setSelectedImg] = useState(null);
  const [inView, setInView] = useState(false);
  const sliderRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => setInView(entry.isIntersecting),
      { threshold: 0.3 }
    );

    if (sliderRef.current) observer.observe(sliderRef.current);
    return () => sliderRef.current && observer.unobserve(sliderRef.current);
  }, []);

  useEffect(() => {
    if (!inView) return;
    const interval = setInterval(() => {
      setSlideIndex((prev) => (prev + 1) % slides.length);
    }, 4000);
    return () => clearInterval(interval);
  }, [inView, slides.length]);

  return (
    <div className="slider-container" ref={sliderRef}>
      <div className="section-title">
        <span>|</span> OUR WORK <span>|</span>
      </div>

      <div className="slider">
        <div className={`slides ${inView ? 'animated' : ''}`}>
          {slides[slideIndex].map((img, i) => (
            <img
              key={i}
              src={img}
              alt={`Work ${i}`}
              onClick={() => setSelectedImg(img)}
              className="slide-img"
            />
          ))}
        </div>
      </div>

      <div className="dots">
        {slides.map((_, index) => (
          <span
            key={index}
            className={`dot ${index === slideIndex ? 'active' : ''}`}
            onClick={() => setSlideIndex(index)}
          ></span>
        ))}
      </div>

      <AnimatePresence>
        {selectedImg && (
          <motion.div
            className="image-modal"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setSelectedImg(null)}
          >
            <div
              className="modal-content"
              onClick={(e) => e.stopPropagation()}
            >
              <motion.img
                key={selectedImg}
                src={selectedImg}
                alt="Zoomed"
                initial={{ y: "-100vh" }}
                animate={{ y: 0 }}
                exit={{ y: "100vh" }}
              />
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default Ourwork;
